<template>
    <div class="row class-menu">
        <div class="col-md-3">
            <input-field label="Start Date" type="calendar" v-model="startDate" :inputConfig="config" />
        </div>
        <div class="col-md-3">
            <input-field label="End Date" type="calendar" v-model="endDate" :inputConfig="config" />
        </div>
        <div class="col-md-3">
            <input-field label="Sign-in Method" type="select" :options="methodOptions" v-model="selectedMethod" />
        </div>
        <div class="col-md-3 text-end">
            <label class="form-label d-block">&nbsp;</label>
            <button v-if="isAqferAdminOrManager" class="btn btn-primary" @click="getReports">
                Generate Report</button
            ><span>&nbsp;</span>
            <button class="btn btn-primary" @click="exportCSV">
                Export CSV
            </button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <div class="card">
                <datatable
                    :key="selectedMethod"
                    :tableId="`sigincredentials-${selectedMethod}`"
                    :columns="columns"
                    uniqueField="email"
                    :formatColumn="formatColumn"
                    :data="signIns"
                    :info="false"
                    :compact="true"
                    :showLoading="signIns === null"
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import csv from "../../../utils/tools/csv"
import dayjs from "dayjs";
import InputField from "../../../components/InputField.vue";
import Datatable from "../../../components/Datatable.vue";
export default {
    components: { InputField, Datatable },
    data() {
        return {
            config: {
                wrap: true,
                dateFormat: 'm-d-Y',
            },
            startDate: dayjs().subtract(7, "day").format("MM/DD/YYYY"),
            endDate: dayjs().format("MM/DD/YYYY"),
            signIns: null,
            formatColumn:[
                {
                    index:1,
                    type:"datetime"
                }
            ],
            methodOptions: [
                { value: "OAUTH2", label: "OAuth" },
                { value: "REFRESH_TOKEN", label: "Refresh Token" },
            ],
            selectedMethod: "OAUTH2",
        };
    },
    watch: {
        selectedMethod() {
            this.getReports();
        }
    },
    methods: {
        getReports() {
            var since = dayjs(this.startDate, 'MM-DD-YYYY').format("YYYYMMDDHHmmss");
            var until = dayjs(this.endDate, 'MM-DD-YYYY').format("YYYYMMDDHHmmss");
            this.signIns = null

            return axios
                .get(
                    `${this.$store.state.authUrl}/v1/sign-ins?cid=${this.$store.state.currentClient.cid}&since=${since}&until=${until}&method=${this.selectedMethod}&all=true`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.state.accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    if (response.data) {
                        this.signIns = response.data;
                    }
                });
        },
        exportCSV() {
            csv.exportCSV("sign-ins", this.signIns)
        }
    },
    computed: {
        columns() {
            let columns = [
                {
                    data: "email",
                    title: "User",
                },
                {
                    data: "sign_in_time",
                    title: "Sign in",
                }
            ];
            //Refresh token id is only recorded for refresh token sign-ins, and is null on older entries
            if (this.selectedMethod === "REFRESH_TOKEN") {
                columns.push({
                    data: "refresh_token_id",
                    title: "Refresh Token ID",
                    defaultContent: "-",
                    render: function (data, type) {
                        return type === 'sort' ? data : (data ? data : "-")
                    }
                })
            }
            return columns;
        },
        isAqferAdminOrManager() {
            return this.$store.getters.userRoles.isAqferAdmin || this.$store.getters.userRoles.isAqferManager;
        }
    },
    mounted () {
        this.getReports()
    }
};
</script>

<style>
</style>